// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { Text } from '@bottlebooks/gatsby-design-system';
import { jsx } from 'theme-ui';

export default function SectionTitle({ children, ...rest }) {
  if (!children) return null;
  return (
    <Text variant="semiTitle" sx={{ marginBottom: 2 }}>
      {children}
    </Text>
  );
}
